var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecializationSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#E8F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3157 21.0339C17.6984 23.2751 19.65 24.9812 22.0004 24.9812C24.3507 24.9812 26.3024 23.2751 26.6851 21.0339H26.7872C27.5567 21.0339 28.1805 20.41 28.1805 19.6406C28.1805 18.871 27.5567 18.2472 26.7872 18.2472H26.7535V17.7312C24.8769 17.2882 23.7245 16.2929 23.1324 15.6228C22.2753 16.3886 20.4132 17.6913 17.2474 18.2314L17.0854 18.2533C16.3761 18.3181 15.8203 18.9143 15.8203 19.6406C15.8203 20.41 16.4441 21.0339 17.2136 21.0339H17.3157Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2471 16.9226C21.1192 16.2016 22.6724 14.2637 22.6881 14.2436L23.2801 13.4857L23.7561 14.3213C23.7915 14.3816 24.6418 15.7954 26.7531 16.3993V15.753C26.7531 13.128 24.6251 11 22.0001 11C19.3751 11 17.2471 13.128 17.2471 15.753V16.9226Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2804 29.1328H28.0796C27.4934 29.1328 27.0166 29.6097 27.0166 30.1958V31.7109H29.3434V30.1958C29.3434 29.6097 28.8665 29.1328 28.2804 29.1328Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 31.7109C16.2949 31.7109 16.6797 31.3262 16.6797 30.8516C16.6797 30.3769 16.2949 29.9922 15.8203 29.9922C15.3457 29.9922 14.9609 30.3769 14.9609 30.8516C14.9609 31.3262 15.3457 31.7109 15.8203 31.7109Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5469 26.0684C23.0456 26.2011 22.5259 26.2701 22.0002 26.2701C21.4746 26.2701 20.9549 26.2012 20.4536 26.0684L22.0002 28.2374L23.5469 26.0684Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6715 30.8517C13.6715 29.8915 14.3047 29.0766 15.1754 28.8022V24.9834L13.4165 25.8086C11.9485 26.4973 11 27.99 11 29.6114V33.0001H15.8199C14.6353 33.0001 13.6715 32.0363 13.6715 30.8517Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5832 25.8086L28.8242 24.9834V27.9081C29.8596 28.1544 30.6322 29.0863 30.6322 30.1959V33.0002H32.9997V29.6115C32.9997 27.99 32.0511 26.4973 30.5832 25.8086Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5359 27.9078V24.3783L26.7217 23.9963C26.5588 24.2004 22.0004 30.4576 22.0004 30.4576C22.0004 30.4576 17.442 24.2005 17.2791 23.9963L16.4648 24.3783V28.8018C17.3356 29.0762 17.9688 29.8912 17.9688 30.8513C17.9688 32.036 17.005 32.9998 15.8203 32.9998H25.728V30.1955C25.728 29.086 26.5006 28.154 27.5359 27.9078Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecializationSectionIcon);
export default __webpack_public_path__ + "static/media/specialization-section-icon.0b75f54d1e0c0d12e0390417b3e3a0d8.svg";
export { ForwardRef as ReactComponent };